import axios from "axios";

const normalizeBaseUrl = (value: string | undefined) =>
  (value || "").replace(/\/+$/, "");

export const getGameApiBaseUrl = () =>
  normalizeBaseUrl(
    process.env.VUE_APP_GAME_API_BASE_URL || process.env.VUE_APP_API_URL
  );

export const getGameApiHeaders = () => {
  const headers: Record<string, string> = {};
  const username = process.env.VUE_APP_API_USERNAME;
  const password = process.env.VUE_APP_API_PASSWORD;

  if (username && password) {
    headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`;
  }

  return headers;
};

export const createGameApiClient = () =>
  axios.create({
    baseURL: getGameApiBaseUrl(),
    headers: getGameApiHeaders(),
  });
